import React, { Component } from 'react';
import './App.css';
import Button from '@mui/material/Button';
import { renderTextField } from './forms';
import { Field, reduxForm } from 'redux-form';

class ResetPassword extends Component {
	constructor(props) {
		super(props)
		this.state ={
		}
	}

	render() {
		return (
			<div>
				<h1 className="auth-title">Reset your password</h1>
				<p className="auth-sub">No worries &mdash; it happens to us all.</p>

				<div className="login-form-row-extra">
					<Field name="email" component={renderTextField} label="Email"/>
				</div>

				<div className="login-form-row">
					<Button variant="contained" className="auth-submit">Reset Password</Button>
				</div>
            </div>
        );
    }
}

// Decorate the form component
ResetPassword = reduxForm({
	form: 'resetPasswordForm' // a unique name for this form
})(ResetPassword);

export default ResetPassword;
